module.exports = __webpack_public_path__ + "static/polar-caseimg@2x-min-9de12e4dc3d1cf460a4a84348d6d8438.png";